// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uC70Q","name":"styles_name__19dF_","phone":"styles_phone__3h4iw"};